export const whiteLabel = {
  seo: {
    title: "Bespire White Label – Indítsd el saját márkás szoftverplatformodat",
    description: "White-label SaaS platform ügynökségeknek, tanácsadóknak és operátoroknak. Indítsd el saját márkás szoftverbizniszedet foglalással, fizetéssel, weboldalakkal, CRM-mel és AI eszközökkel.",
    keywords: "white label SaaS, white label platform, márkás ügyfélplatform, SaaS viszonteladó, partnerplatform, vertikális SaaS",
  },
  navbar: {
    overview: "Áttekintés",
    whoItsFor: "Kinek szól",
    features: "Funkciók",
    models: "Modellek",
    howItWorks: "Hogyan működik",
    faq: "GYIK",
    bookCall: "Időpont foglalás",
  },
  hero: {
    badge: "White Label Partner Program",
    title: "Indítsd el saját márkás szoftverplatformodat anélkül, hogy nulláról építenéd fel.",
    subtitle: "A Bespire White Label segít ügynökségeknek, operátoroknak és partnereknek saját SaaS ajánlatot indítani saját márkával, gyorsabban, karcsúbban és kisebb kockázattal.",
    primaryCta: "Stratégiai hívás foglalása",
    secondaryCta: "Hogyan működik",
    trustItems: [
      "Európai platform",
      "AI-natív alapok",
      "Moduláris & skálázható",
    ],
  },
  whoItsFor: {
    label: "Kinek szól",
    title: "Platformban gondolkodó operátoroknak készült.",
    subtitle: "Akár ügynökséget, franchise-t vagy tanácsadói üzletet vezetsz — a Bespire White Label technológiai alapot ad, amit saját márkád alatt értékesíthetsz.",
    cards: [
      {
        title: "Ügynökségek",
        pain: "Az ügyfelek többet várnak, mint kampányokat. Eszközöket akarnak.",
        outcome: "Kínálj márkás ügyfélplatformot a szolgáltatásaid mellé.",
        icon: "building2",
      },
      {
        title: "Tanácsadók",
        pain: "A módszertanod prezentációkban és táblázatokban él.",
        outcome: "Csomagold be a folyamatodat márkás szoftverélménnyé.",
        icon: "briefcase",
      },
      {
        title: "Franchise operátorok",
        pain: "Minden helyszín más eszközöket és folyamatokat használ.",
        outcome: "Egységesítsd a működést egy márkás platform alatt.",
        icon: "network",
      },
      {
        title: "Oktatási hálózatok",
        pain: "A képzési programok skálázása szétszórt eszközöket igényel.",
        outcome: "Nyújtsd a kurzusokat, foglalásokat és tartalmakat saját márkád alatt.",
        icon: "graduationCap",
      },
      {
        title: "Coaching vállalkozások",
        pain: "Az 1-on-1-en túli növekedés a személyes touch elvesztésével jár.",
        outcome: "Skálázd a coachingodat márkás digitális utakkal.",
        icon: "heart",
      },
      {
        title: "Wellness & fitness hálózatok",
        pain: "A stúdiók és edzők mind más szoftvert használnak.",
        outcome: "Egyesítsd a hálózatodat egy márkás platformmal.",
        icon: "dumbbell",
      },
      {
        title: "Szoftver viszonteladók",
        pain: "Generikus eszközök viszonteladása árversenyt jelent.",
        outcome: "Sajátítsd ki a márkát, a kapcsolatot és a haszonkulcsot.",
        icon: "shoppingBag",
      },
    ],
  },
  opportunity: {
    label: "A lehetőség",
    title: "Miért a white-label a legokosabb út a SaaS bevételhez.",
    subtitle: "Ne cseréld az idődet pénzre. Építs visszatérő bevételi üzletet bevált technológiai alapon.",
    items: [
      {
        title: "Visszatérő bevétel",
        description: "Építs kiszámítható MRR-t szoftver csomagolásával saját márkád alatt és ügyfeleidnek történő értékesítésével.",
        icon: "trendingUp",
      },
      {
        title: "Gyorsabb piacra lépés",
        description: "Ugorj át éveket a fejlesztésből. Lépj piacra heteken belül, ne negyedévek múlva.",
        icon: "zap",
      },
      {
        title: "Nincs szükség teljes fejlesztésre",
        description: "Kapj foglalást, fizetést, weboldalakat, CRM-et és automatizálást mérnöki csapat felvétele nélkül.",
        icon: "code",
      },
      {
        title: "Sajátítsd ki a márkát & kapcsolatot",
        description: "Ügyfeleid a te márkádat, domainedet, arculatodat látják. A Bespire láthatatlan marad.",
        icon: "palette",
      },
      {
        title: "Niche pozicionálás",
        description: "Konfiguráld a platformot a vertikálumodhoz — fitness, wellness, coaching, tanácsadás, oktatás vagy bármely rés.",
        icon: "target",
      },
      {
        title: "Szolgáltatásból SaaS",
        description: "Bővítsd szolgáltatási üzletedet skálázható szoftverüzletté visszatérő bevétellel.",
        icon: "arrowUpRight",
      },
    ],
  },
  features: {
    label: "Mit értékesíthetsz",
    title: "Minden, amire ügyfeleidnek szüksége van. A te márkád alatt.",
    subtitle: "A Bespire biztosítja a moduláris technológiai vermet. Te határozod meg a csomagolást, az árazást és a pozicionálást.",
    items: [
      { title: "Weboldal építő", description: "Márkás webes jelenlét minden ügyfélnek", icon: "globe" },
      { title: "Foglalás & ütemezés", description: "Naptár, elérhetőség és időpontkezelés", icon: "calendar" },
      { title: "Lead capture tölcsérek", description: "Landing oldalak és konverziós folyamatok", icon: "filter" },
      { title: "Online fizetés", description: "Biztonságos fizetések, számlázás és pénztár", icon: "creditCard" },
      { title: "Tagságok", description: "Előfizetések, hozzáférési szintek és visszatérő számlázás", icon: "users" },
      { title: "Digitális termékek", description: "Kurzusok, tartalmak, letöltések és ajánlatok", icon: "package" },
      { title: "Ügyfélútvonalak", description: "Onboarding folyamatok és vezetett élmények", icon: "map" },
      { title: "CRM munkafolyamatok", description: "Ügyfélkezelés, címkék és szegmensek", icon: "database" },
      { title: "Automatizálás", description: "Emlékeztetők, követések és triggerelt műveletek", icon: "bot" },
      { title: "AI növekedési eszközök", description: "AI-támogatott tartalom, elérés és optimalizálás", icon: "sparkles" },
      { title: "Analitika", description: "Riportolás, dashboardok és üzleti intelligencia", icon: "barChart" },
      { title: "Vertikális konfigurációk", description: "Iparág-specifikus beállítások és sablonok", icon: "settings" },
    ],
  },
  comparison: {
    label: "Miért ne építsd magad?",
    title: "Három út. Egy egyértelmű győztes.",
    subtitle: "Hasonlítsd össze a lehetőségeket és lásd, miért a Bespire White Label az optimális út sebességet, tulajdonlást és skálázhatóságot kereső operátoroknak.",
    headers: {
      criteria: "Szempont",
      buildFromScratch: "Építsd nulláról",
      resellTools: "Viszonteladj szétszórt eszközöket",
      bespire: "Bespire White Label",
    },
    rows: [
      { criteria: "Piacra jutási idő", scratch: "12-24 hónap", tools: "1-3 hónap", bespire: "4-8 hét" },
      { criteria: "Fejlesztési költség", scratch: "€200K-€1M+", tools: "Alacsony", bespire: "Kiszámítható & karcsú" },
      { criteria: "Márkatulajdonlás", scratch: "Teljes", tools: "Korlátozott", bespire: "Teljes" },
      { criteria: "Funkció mélység", scratch: "Egyedi", tools: "Töredezett", bespire: "Teljes & moduláris" },
      { criteria: "Karbantartási teher", scratch: "Magas", tools: "Közepes", bespire: "Menedzselt" },
      { criteria: "Skálázhatóság", scratch: "Függ", tools: "Korlátozott", bespire: "Beépített" },
      { criteria: "AI képességek", scratch: "Építsd magad", tools: "Nincs", bespire: "Natív" },
      { criteria: "Ügyfélkapcsolat", scratch: "Tiéd", tools: "Megosztott", bespire: "Tiéd" },
      { criteria: "Kockázati szint", scratch: "Nagyon magas", tools: "Közepes", bespire: "Alacsony" },
    ],
  },
  howItWorks: {
    label: "Hogyan működik",
    title: "Az első hívástól az éles platformig heteken belül.",
    subtitle: "Strukturált, átlátható folyamat komoly operátoroknak tervezve.",
    steps: [
      {
        number: "01",
        title: "Felfedező hívás",
        description: "Megismerjük az üzletedet, piacodat és céljaidat. Te megismered a Bespire képességeit.",
      },
      {
        number: "02",
        title: "Minősítés & illeszkedés",
        description: "Felmérjük a kölcsönös illeszkedést — a felhasználási eseted, célpiacod és partnerségi modell kompatibilitását.",
      },
      {
        number: "03",
        title: "Modell meghatározás",
        description: "Közösen definiáljuk a white-label modellt, hatókört, árstruktúrát és kereskedelmi feltételeket.",
      },
      {
        number: "04",
        title: "Márka & csomagolás beállítás",
        description: "A te márkád, a te domained, a te pozicionálásod. Konfiguráljuk a platformot az arculatodnak megfelelően.",
      },
      {
        number: "05",
        title: "Pilot indítás",
        description: "Indulj el az első ügyfeleiddel vagy helyszíneiddel. Teszteld, tanulj és finomítsd az ajánlatot.",
      },
      {
        number: "06",
        title: "Skálázás",
        description: "Terjeszd ki új ügyfelekre, vertikálisokra vagy földrajzi területekre bevált, márkás platformmal.",
      },
    ],
  },
  models: {
    label: "Partnerségi modellek",
    title: "Válaszd ki az üzletedhez illő modellt.",
    subtitle: "A Bespire White Label többféle partnerségi struktúrát támogat. Válaszd azt, amelyik illeszkedik a piacra lépési stratégiádhoz.",
    items: [
      {
        title: "Viszonteladó",
        description: "Vásárolj licenceket partneri áron, értékesítsd saját márkád alatt saját árazásoddal. Egyszerű, skálázható, margin-vezérelt.",
        bestFor: "Ügynökségek, szoftverdisztribútorok, szolgáltató cégek",
        icon: "repeat",
      },
      {
        title: "Menedzselt szolgáltatás",
        description: "Csomagold össze a platformot a tanácsadásoddal, implementációddal vagy menedzselt szolgáltatásaiddal. Nyújts teljes körű megoldást.",
        bestFor: "Tanácsadók, implementációs partnerek, menedzselt szolgáltatók",
        icon: "settings",
      },
      {
        title: "Vertikális megoldás",
        description: "Konfiguráld a platformot egy specifikus iparági vertikálishoz. Sajátítsd ki a niche pozicionálást és piaci szakértelmet.",
        bestFor: "Niche operátorok, vertikális SaaS építők, iparági specialisták",
        icon: "layers",
      },
      {
        title: "Hálózat / Multi-brand",
        description: "Telepítsd a platformot helyszínek, franchise-ok vagy almárkák hálózatára. Centralizált irányítás, lokalizált márkák.",
        bestFor: "Franchise hálózatok, többhelyszínes operátorok, márkcsoportok",
        icon: "network",
      },
      {
        title: "Stratégiai implementáció",
        description: "Mély integráció a meglévő ökoszisztémáddal. Közös funkciófejlesztés és piacra lépési stratégia.",
        bestFor: "Enterprise partnerek, stratégiai szövetségek, platform ökoszisztémák",
        icon: "handshake",
      },
    ],
  },
  useCases: {
    label: "Valós forgatókönyvek",
    title: "Hogyan használják partnerek a Bespire White Label-t.",
    subtitle: "Gyakorlati példák arra, hogyan építenek különböző vállalkozások visszatérő bevételt a Bespire alapon.",
    cases: [
      {
        title: "Ügynökségi növekedési platform",
        description: "Egy marketing ügynökség elindítja saját márkás ügyfélnövekedési platformját — weboldalakat, foglalást, tölcséreket és CRM-et kombinálva a márkája alatt. Az ügyfelek havonta fizetnek, az ügynökség visszatérő bevételt keres.",
        industry: "Marketing & Digitális",
      },
      {
        title: "Wellness hálózat",
        description: "Egy wellness franchise márkás szoftvert kínál stúdióinak és független oktatóinak. Foglalás, fizetés és ügyfélkezelés — mind a hálózat márkája alatt.",
        industry: "Wellness & Fitness",
      },
      {
        title: "Vertikális SaaS lépés",
        description: "Egy tanácsadó niche SaaS ajánlatot hoz létre táplálkozási szakembereknek — ütemezést, tartalomszolgáltatást és ügyfélútvonalakat kombinálva egy márkás termékbe.",
        industry: "Egészség & Tanácsadás",
      },
      {
        title: "Franchise szabványosítás",
        description: "Egy franchise hálózat szabványosítja a digitális működést 50+ helyszínen. Minden helyszín saját márkás alplatformot kap centralizált riportolással.",
        industry: "Franchise & Működés",
      },
      {
        title: "Alkotói operációs rendszer",
        description: "Egy e-learning vállalkozás márkás operációs rendszert indít szakértő hálózatának — lehetővé téve kurzusok, foglalások, fizetések és közösség egy fedél alatt.",
        industry: "Oktatás & Alkotók",
      },
    ],
  },
  whyBespire: {
    label: "Miért Bespire",
    title: "Partnereknek épített platform, nem csak végfelhasználóknak.",
    subtitle: "A Bespire az alapoktól úgy van tervezve, hogy támogassa a white-label telepítést, niche vertikalizációt és partnervezérelt növekedést.",
    points: [
      { title: "Európai piaci DNS", description: "Európai érzékenységgel épített — többnyelvű, többdevizás, adatvédelem-tudatos és kulturálisan rugalmas." },
      { title: "Rugalmas megközelítés", description: "Nincsenek merev sablonok. Konfiguráld a platformot a piacod, a niche-ed és az üzleti logikád szerint." },
      { title: "Prémium termékirány", description: "Olyan termék, amelyre ügyfeleid büszkék lesznek. Modern, gyors és gyönyörűen megtervezett." },
      { title: "AI-natív alap", description: "Az AI nem egy kiegészítő. Beépült a platformba — tartalomkészítéstől az ügyfélkapcsolatig az automatizálásig." },
      { title: "Partner-first gondolkodás", description: "Mi akkor sikerülünk, ha partnereink sikerülnek. Az ütemtervünk, árazásunk és támogatásunk ezt tükrözi." },
      { title: "Moduláris skálázhatóság", description: "Kezdj egy modullal. Skálázz a teljes stackre. Adj hozzá funkciókat, ahogy ügyfeleid nőnek." },
      { title: "Sebesség + stratégiai támogatás", description: "Gyors indítások kézzelfogható támogatással. Nem önkiszolgáló platform — stratégiai partnerség." },
      { title: "Komoly operátoroknak készült", description: "Nem DIY eszköz. Professzionális platform partnereknek, akik valódi üzletet akarnak építeni." },
    ],
  },
  faq: {
    label: "Gyakran ismételt kérdések",
    title: "Minden, amit tudnod kell.",
    items: [
      {
        question: "Pontosan mit jelent itt a white-label?",
        answer: "A white-label azt jelenti, hogy átveszed a Bespire platformot, rárakod a saját márkádat (logó, színek, domain, pozicionálás), és saját termékedként értékesíted az ügyfeleidnek. A Bespire láthatatlan marad a végfelhasználóid számára.",
      },
      {
        question: "Használhatjuk a saját márkánkat és domainünket?",
        answer: "Természetesen. A te márkád, a te domained, a te arculatod. Ügyfeleid soha nem látják a Bespire nevet, hacsak te nem akarod.",
      },
      {
        question: "Adaptálható a megoldás a mi niche-ünkhöz?",
        answer: "Igen. A platform moduláris és konfigurálható. Aktiválhatsz, deaktiválhatsz és testreszabhatsz funkciókat a specifikus vertikálisodhoz — legyen az fitness, tanácsadás, oktatás vagy bármely más terület.",
      },
      {
        question: "Ez jobb, mint egyedi szoftvert építeni?",
        answer: "A legtöbb operátor számára igen. A nulláról építés 12-24 hónapot és jelentős befektetést igényel. A Bespire White Label-lel heteken belül indulhatsz egy bevált, karbantartott és fejlődő platformmal.",
      },
      {
        question: "Ki birtokolja az ügyfélkapcsolatot?",
        answer: "Te. Az ügyfeleid a te ügyfeleid. Te határozod meg az árazást, te kezeled a kapcsolatot, és a bevétel is a tiéd. A Bespire a technológiai partnered, nem a versenytársad.",
      },
      {
        question: "Meghatározhatjuk a saját árazásunkat?",
        answer: "Igen. Te határozod meg az árazást az ügyfeleid számára. A Bespire partner szintű árazást biztosít neked, te pedig meghatározod a haszonkulcsodat és csomagolási stratégiádat.",
      },
      {
        question: "Támogatjátok a többhelyszínes vagy többügyfeles felállásokat?",
        answer: "Igen. A platform multi-tenant telepítésre lett tervezve. Akár 5 ügyfeled, akár 500 helyszíned van, az architektúra támogatja.",
      },
      {
        question: "Kezdhetünk pilottal?",
        answer: "Feltétlenül. Javasoljuk, hogy fókuszált pilottal kezdj — néhány ügyfél vagy egy vertikális — hogy validáld a modellt a skálázás előtt.",
      },
      {
        question: "Milyen típusú partnerek a legjobb illeszkedés?",
        answer: "Partnerek, akiknek már van ügyfélbázisuk, iparági szakértelmük és vágyuk visszatérő szoftverbevételt adni az üzletükhöz. Ügynökségek, tanácsadók, franchise operátorok és niche specialisták ideálisak.",
      },
      {
        question: "Mennyi ideig tart általában az indítás?",
        answer: "Az aláírt megállapodástól az éles platformig: jellemzően 4-8 hét, a testreszabási hatókörtől és a márkabeállítás összetettségétől függően.",
      },
      {
        question: "Mi tartozik a partnerségbe?",
        answer: "Platform hozzáférés, white-label konfiguráció, onboarding támogatás, partneri árazás, technikai dokumentáció és folyamatos termékfrissítések. Stratégiai partnerek dedikált account menedzsmentet is kapnak.",
      },
      {
        question: "Ez csak ügynökségeknek alkalmas?",
        answer: "Egyáltalán nem. Bár az ügynökségek erős illeszkedést jelentenek, dolgozunk tanácsadókkal, franchise hálózatokkal, oktatási platformokkal, wellness hálózatokkal és bármilyen operátorral, aki márkás szoftvert akar indítani.",
      },
    ],
  },
  booking: {
    label: "Időpont foglalás",
    title: "Fedezzük fel a white-label modelledet.",
    subtitle: "Foglalj stratégiai hívást és feltérképezzük, hogy a Bespire White Label illeszkedik-e a piacod, ajánlatod és üzleti modelled számára.",
    calendarPlaceholder: "Miért érdemes felvenni a kapcsolatot?",
    calendarNote: "Egy rövid beszélgetés alatt kiderítjük, hogy a Bespire White Label hogyan illeszkedik a te üzleti modelled.",
    calendarCta: "Visszahívást kérek",
    calendarTrust: "Kötelezettségmentes · 30 perc · Személyre szabott",
    calendarReasons: [
      { title: "Személyre szabott ajánlat", description: "Nem sablonos demo-t kapsz, hanem a te piacod és célcsoportod alapján összeállított stratégiát." },
      { title: "Konkrét menetrend", description: "Megmutatjuk, milyen lépésekkel indíthatod el a saját márkás platformodat akár heteken belül." },
      { title: "ROI kalkuláció", description: "Kiszámoljuk, milyen bevételi potenciált jelent számodra a white-label modell." },
      { title: "Kockázatmentes", description: "Nincs kötelezettség, nincs rejtett költség — csak egy értékes, 30 perces szakmai konzultáció." },
      { title: "Partner anyagok", description: "A hívás után megkapod a részletes partner deck-et és az egyedi árajánlatot." },
    ],
    form: {
      title: "Mesélj az üzletedről",
      name: "Teljes név",
      namePlaceholder: "A neved",
      company: "Cég",
      companyPlaceholder: "A céged neve",
      email: "Email",
      emailPlaceholder: "te@ceged.hu",
      website: "Weboldal",
      websitePlaceholder: "https://ceged.hu",
      businessType: "Üzlet típusa",
      businessTypePlaceholder: "Válaszd ki az üzlettípusodat",
      businessTypes: {
        agency: "Ügynökség",
        consultant: "Tanácsadó / Mentor",
        franchise: "Franchise / Többhelyszínes",
        education: "Oktatás / Képzés",
        coaching: "Coaching / Mentoring",
        wellness: "Wellness / Fitness",
        reseller: "Szoftver viszonteladó",
        other: "Egyéb",
      },
      targetNiche: "Célterület",
      targetNichePlaceholder: "pl. Fitness stúdiók, szépségszalonok, coaching...",
      clientCount: "Hozzávetőleges ügyfélszám",
      clientCountPlaceholder: "Válassz tartományt",
      clientCounts: {
        range1: "1-10",
        range2: "11-50",
        range3: "51-200",
        range4: "200+",
      },
      model: "Melyik white-label modell érdekel?",
      modelPlaceholder: "Válassz modellt",
      models: {
        reseller: "Viszonteladó",
        managed: "Menedzselt szolgáltatás",
        vertical: "Vertikális megoldás",
        network: "Hálózat / Multi-brand",
        strategic: "Stratégiai implementáció",
        notSure: "Még nem tudom",
      },
      timeline: "Időkeret",
      timelinePlaceholder: "Válassz időkeretet",
      timelines: {
        asap: "Minél hamarabb",
        oneToThree: "1-3 hónap",
        threeToSix: "3-6 hónap",
        exploring: "Csak tájékozódom",
      },
      message: "Üzenet",
      messagePlaceholder: "Mesélj a víziódról, piacodról vagy bármilyen kérdésedről...",
      submit: "Küldés & hívás foglalása",
      submitting: "Küldés...",
      successTitle: "Köszönjük!",
      successMessage: "Megkaptuk az érdeklődésedet. Csapatunk 24 órán belül felveszi veled a kapcsolatot a stratégiai hívás egyeztetéséhez.",
    },
  },
  ctaBanner: {
    title: "Készen állsz saját márkás platformod elindítására?",
    subtitle: "Csatlakozz a partner programhoz és kezdj el visszatérő SaaS bevételt építeni.",
    cta: "Stratégiai hívás foglalása",
    secondaryCta: "Partner anyag kérése",
  },
  finalCta: {
    title: "Fedezd fel a white-label növekedési modelledet a Bespire-ral.",
    subtitle: "A technológia kész. A modell bevált. A kérdés az: készen állsz az indításra?",
    primaryCta: "Hívás foglalása",
    secondaryCta: "Partner információ kérése",
  },
  footer: {
    description: "A white-label platform ügynökségeknek, operátoroknak és partnereknek, akik márkás szoftverüzletet akarnak indítani.",
    product: "Termék",
    overview: "Platform áttekintés",
    features: "Funkciók",
    models: "Partneri modellek",
    pricing: "Árazás",
    company: "Cég",
    about: "A Bespire-ról",
    partners: "Partner program",
    careers: "Karrier",
    contact: "Kapcsolat",
    legal: "Jogi",
    privacy: "Adatvédelmi irányelvek",
    terms: "Felhasználási feltételek",
    cookies: "Cookie szabályzat",
    imprint: "Impresszum",
    location: "Budapest, Magyarország",
    allRightsReserved: "Minden jog fenntartva.",
  },
};
